
import { ReportEngineSettings } from "@/utils/report-engine-settings/report-engine-settings";
import Vue from "vue";
export default Vue.extend({
	props: {
		settings: {
			type: Object as ()=>ReportEngineSettings,
			required: true
		}
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
